import { createFileRoute } from '@tanstack/react-router'
import { PengaturanDesa } from '../../../../components/PengaturanDesa'
import { bacaSectionParam, type SectionPengaturan, useScrollToSection } from '../../../../hooks/useScrollToSection'

// G2: lihat alasan `?section=` di routes/desa/$slug/dashboard/pengaturan.tsx — shell platform
// membuka halaman pengaturan yang sama, jadi diperlakukan sama pula.
export const Route = createFileRoute('/platform/desa/$desaId/pengaturan')({
  component: PengaturanPlatformRoute,
  validateSearch: (search: Record<string, unknown>): { section?: SectionPengaturan } => ({
    section: bacaSectionParam(search.section),
  }),
})

function PengaturanPlatformRoute() {
  const { desaId } = Route.useParams()
  const { section } = Route.useSearch()
  useScrollToSection(section)

  return <PengaturanDesa desaId={desaId} />
}
